
import { PackageData } from "@/pages/CreatePackage";
import { companyName } from './constants';

export const renderCommonSection = (sectionId: string, packageData: PackageData): string | null => {
    switch (sectionId) {
        case 'notes':
            if (!packageData.notes) return '';
            return `<div class="section"><h3>📝 ملاحظات</h3><p style="line-height: 1.6;">${packageData.notes}</p></div>`;
        case 'inclusions':
            if (!packageData.inclusions || packageData.inclusions.length === 0) return '';
            return `<div class="section">
                      <h3>✅ ما يشمله العرض</h3>
                      <ul style="margin: 0; padding-right: 20px; line-height: 2;">
                        ${packageData.inclusions.map(item => `<li>${typeof item === 'string' ? item : item.text_ar}</li>`).join('')}
                      </ul>
                    </div>`;
        case 'exclusions':
            if (!packageData.exclusions || packageData.exclusions.length === 0) return '';
            return `<div class="section">
                      <h3>❌ ما لا يشمله العرض</h3>
                      <ul style="margin: 0; padding-right: 20px; line-height: 2; color: #666;">
                        ${packageData.exclusions.map(item => `<li>${typeof item === 'string' ? item : item.text_ar}</li>`).join('')}
                      </ul>
                    </div>`;
        case 'terms':
            return `<div class="section">
                      <h3>📋 الشروط والأحكام</h3>
                      <p style="font-size: 0.85em; line-height: 1.8; color: #555;">
                        • جميع الأسعار قابلة للتغيير بدون إشعار مسبق<br>
                        • الحجز غير مؤكد حتى يتم الدفع الكامل<br>
                        • تطبق شروط الإلغاء حسب سياسة الشركة<br>
                        • يجب على العميل التأكد من صلاحية جواز السفر والتأشيرات اللازمة<br>
                        • الشركة غير مسؤولة عن أي تأخير أو إلغاء من قبل شركات الطيران أو الفنادق
                      </p>
                    </div>`;
        case 'itinerary':
            return `<div class="section">
                      <h3>🗓️ جدول الرحلة المقترح</h3>
                      <p style="font-size: 0.85em; line-height: 1.6; color: #555;">
                        هذا الجدول هو مجرد اقتراح ويمكن تخصيصه حسب رغباتكم. سيتم تزويدكم بالجدول النهائي والتفصيلي بعد تأكيد الحجز.
                      </p>
                    </div>`;
        case 'contact':
            return `<div class="section">
                      <h3>📞 للتواصل والحجز</h3>
                      <p style="line-height: 1.8;">
                        لا تترددوا في التواصل معنا لأي استفسارات أو لتأكيد حجزكم.<br>
                        فريقنا في خدمتكم على مدار الساعة.<br><br>
                        <strong>${companyName}</strong><br>
                        📧 info@example.com<br>
                        📱 +966 12 345 6789<br>
                        🌐 www.example.com
                      </p>
                    </div>`;
        case 'offers':
            return `<div class="section" style="background: linear-gradient(135deg, #fff3cd 0%, #fffbef 100%); border-right: 4px solid #ffc107;">
                      <h3>🎁 عروض خاصة</h3>
                      <p style="line-height: 1.6;">
                        احصل على <strong style="color: #d9534f;">خصم 10%</strong> على الجولات السياحية عند حجز هذا العرض خلال <strong>48 ساعة</strong>!<br>
                        * العرض ساري المفعول حتى ${new Date(Date.now() + 2 * 24 * 60 * 60 * 1000).toLocaleDateString('ar-SA')}
                      </p>
                    </div>`;
        case 'services':
            if (!packageData.services || packageData.services.length === 0) return '';
            return `<div class="section">
                      <h3>🎫 خدمات إضافية</h3>
                      ${packageData.services.map(service => `
                        <div class="item" style="margin-bottom: 10px;">
                          <div style="display: flex; justify-content: space-between;">
                            <strong>${service.name_ar || 'خدمة'}</strong>
                            <span style="color: #28a745; font-weight: bold;">$${service.price || 0}</span>
                          </div>
                          ${service.description_ar ? `<p style="margin: 5px 0 0 0; font-size: 13px; color: #666;">${service.description_ar}</p>` : ''}
                        </div>
                      `).join('')}
                    </div>`;
        default:
            return null;
    }
};
